import React from "react";
import styled, { css, RuleSet } from "styled-components";
import { compassLightGreen, lightGreyOutline } from "../../styles";
import { LoadingTableCell as LoadingPlaceholder } from "../tables/LoadingTableCell";
import { pulse } from "../containers/styledComponents";
import { Icon, IconContainer } from "./styledComponents";
import { ElementContainer } from "../containers/styledComponents";

const ButtonContainer = styled.div<{
  isLoading: boolean;
  w?: string;
  he: boolean;
  small?: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  min-height: ${({ small }): string => (small ? "32px" : "53px")};
  max-height: ${({ small }): string => (small ? "32px" : "53px")};
  margin-left: 12px;
  width: ${({ w }): string => w || "auto"};
  border: 1px solid ${lightGreyOutline};
  border-radius: 7px;
  background-color: white;
  cursor: pointer;
  &:hover {
    border: 1px solid
      ${({ isLoading }): string =>
        isLoading ? lightGreyOutline : compassLightGreen};
  }
  background-color: ${({ isLoading }): string =>
    isLoading ? "#D3D3D3" : "white"};
  ${({ isLoading }): false | RuleSet<object> | undefined =>
    isLoading &&
    css`
      animation: ${pulse} 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
    `}
`;

export const PageButton = ({
  content,
  image,
  w,
  action,
  isLoading = false,
  he = false,
  small = false,
}: PageButtonProps): JSX.Element => {
  return (
    <ButtonContainer
      w={w}
      he={he}
      small={small}
      isLoading={isLoading}
      onClick={!isLoading ? action : undefined}
    >
      <ElementContainer ai="center" cursor="pointer">
        {image && (
          <IconContainer cursor="pointer">
            <Icon src={image} />
          </IconContainer>
        )}
        {isLoading ? <LoadingPlaceholder /> : content}
      </ElementContainer>
    </ButtonContainer>
  );
};

type PageButtonProps = {
  content: JSX.Element;
  image?: string;
  w?: string;
  action?: () => void;
  isLoading?: boolean;
  he?: boolean;
  small?: boolean;
};
